import { addToastNotification } from "@kaizen/notification"

const useNotifications = () => {
  return {
    showNotification: addToastNotification,
  }
}

export default useNotifications
